import { Box, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { Payload } from 'recharts/types/component/DefaultTooltipContent';

function CustomTooltip<T extends { name?: string }>({
  active,
  payload,
  label,
  filterFn,
  nameFormatter,
  valueFormatter,
}: {
  active?: boolean;
  payload?: Payload<string, string>[];
  label?: string;
  nameFormatter: (item: Payload<string, string>) => string;
  valueFormatter: (item: Payload<string, string>) => string;
  filterFn: (item: Payload<string, string>) => boolean;
}) {
  if (active && payload && payload.length) {
    return (
      <Box bg="white" p={10} style={{ border: '1px solid #ccc' }}>
        <Stack gap={4}>
          <Text>{dayjs(label).locale('en').format('MMM, YYYY')}</Text>
          {payload
            .filter((item) => filterFn(item as T))
            .filter((item) => Boolean(item.name) && item.value !== undefined)
            .map((item) => {
              return (
                <Text
                  key={String(item.dataKey)}
                  c={item.stroke}
                >{`${nameFormatter(item!)}: ${valueFormatter(item!)}`}</Text>
              );
            })}
        </Stack>
      </Box>
    );
  }

  return null;
}

export { CustomTooltip };
